<div class="d-flex justify-content-between cart-discounted-price-wrap">
  <div [translate]="'cart.promoCode.discount'">Discount</div>
  <div class="fw-bold">
    - {{discountedPrice | currencyFormat: currency}}
  </div>
</div>
